<template>
  <main>
    <div class="container-fluid devoir">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template #right-element>
              <router-link :to="{name: 'AddRegister'}" class="btn button btn-primary" :disabled="!loading">
                <i class="icon-Add" />
                {{ $t("button.addFapp") }}
              </router-link>
            </template>
            <template #left-element>
              <h3>{{ $t("title.feuilleAppel") }}</h3>
            </template>
          </TopTemplate>
        </div>
      </div>

      <div class="ajout-container row bloc container-select container-filter">
        <div class="col-sm-8 container-select container-filter top-filter">
          <div class="info-filter">
            <p>{{ $t("register.filter.title") }}</p>
            <span>{{ $t("register.filter.description") }}</span>
          </div>
        </div>
        <div v-if="isSelected" class="col-sm-4 container-select container-filter top-filter">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
        <div class="supparation"></div>

        <div class="row container-select container-filter top-register">
          <div class="col-md-5 col-12 select-wrapper bloc-title">
            <div>
              <v-select
                v-model="selectedLevel"
                :searchable="true"
                :options="levels"
                label="name"
                class="form-control"
                :reduce="(option) => option"
                @update:modelValue="ChangeLevel($event)"
                placeholder="Niveau"
              >
                <template #no-options="{loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearshType") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-5 col-12 select-wrapper">
            <div>
              <v-select
                v-model="selectedClass"
                :options="classes"
                label="name"
                placeholder="Classe"
                :searchable="true"
                :disabled="!selectedLevel || selectedLevel.length === 0"
                :reduce="(option) => option"
                class="form-control"
                @update:modelValue="ChangeClass($event)"
              >
                <template #no-options="{loading}">
                  <div v-if="!loading" class="card mt-2 text-center d-block pt-2 pb-2">
                    {{ $t("common.emptysearchClasse") }}
                  </div>
                  <div v-else class="card mt-2 text-center d-block pt-2 pb-24">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 register-clalender">
          <FullCalendar :options="options"> </FullCalendar>
        </div>
        <div class="col-lg-8 collapse-register">
          <div v-if="loading" class="mt-4 text-center d-block pt-4 pb-4">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div v-if="inputText && this.register.length === 0 && selectedClass" class="top-msg">
            <p>{{ $t("register.msgNull") }}</p>
          </div>
          <div v-if="!selectedClass" class="top-msg">
            <p>{{ $t("register.msg") }}</p>
          </div>
          <div v-if="this.register.length > 0" class="top-date">
            <p>{{ $t("register.dateSuivi") }} {{ formattedDate }}</p>
          </div>
          <div v-for="(item, index) in this.register" :key="item.id" class="general-info">
            <div class="accordion" @click="toggleCollapse(index)">
              <div class="col-md-4 left">
                <span class="time"> {{ formatHours(item.start_time) }} - {{ formatHours(item.end_time) }}</span>
                <span class="course">{{ item.course_name }}</span>
              </div>
              <div class="col-md-7 right">
                <div class="right__nbr-eleve">
                  <span v-if="item.count_absent > 0 || item.count_delay > 0 || item.count_exclu > 0">
                    <span :class="{absent: item.count_absent >= 0}">Absent :</span>
                    {{ item.count_absent }} {{ item.count_absent > 1 ? "élèves" : "élève" }} | <span :class="{retard: item.count_delay >= 0}">Retard :</span>
                    {{ item.count_delay }} {{ item.count_delay > 1 ? "élèves" : "élève" }} |
                    <span :class="{absent: item.count_exclu >= 0}"> Exclu :</span>
                    {{ item.count_exclu }} {{ item.count_exclu > 1 ? "élèves" : "élève" }}
                  </span>
                  <span class="nothing-report" v-else>Rien à signaler</span>
                </div>
                <div class="right__icons-wrapper">
                  <i :class="{'icon-Minus color-green': item.expanded, 'icon-Add color-green': !item.expanded}"></i>
                </div>
              </div>
            </div>
            <div class="panel collapse-contenu" v-show="item.expanded">
              <div class="top-name-eleve">
                <div v-if="absentStudents(item).length > 0" class="absent">
                  <div class="title">Absent</div>
                  <div class="name-eleve">
                    <p v-for="student in absentStudents(item)" :key="student.id">
                      {{ student.first_name }} {{ student.last_name }}
                      <span v-if="student.remark" class="mark">
                        <img src="../../assets/icons/Icon.png" />
                        <span class="tooltiptext">{{ student.remark }}</span></span
                      >
                    </p>
                  </div>
                </div>
                <div v-if="delayedStudents(item).length > 0" class="retard">
                  <div class="title">Retard</div>
                  <div class="name-eleve">
                    <p v-for="student in delayedStudents(item)" :key="student.id">
                      {{ student.first_name }} {{ student.last_name }}
                      <span v-if="student.remark" class="mark">
                        <img src="../../assets/icons/Icon.png" />

                        <span class="tooltiptext">{{ student.remark }}</span></span
                      >
                    </p>
                  </div>
                </div>
                <div v-if="excluStudents(item).length > 0" class="absent">
                  <div class="title">Exclu</div>
                  <div class="name-eleve">
                    <p v-for="student in excluStudents(item)" :key="student.id">
                      {{ student.first_name }} {{ student.last_name }}
                      <span v-if="student.remark" class="mark">
                        <img src="../../assets/icons/Icon.png" />

                        <span class="tooltiptext">{{ student.remark }}</span></span
                      >
                    </p>
                  </div>
                </div>
                <div v-if="presentWithRemarkStudents(item).length > 0" class="retard">
                  <div class="title">Présent</div>
                  <div class="name-eleve">
                    <p v-for="student in presentWithRemarkStudents(item)" :key="student.id">
                      {{ student.first_name }} {{ student.last_name }}
                      <span v-if="student.remark" class="mark">
                        <img src="../../assets/icons/Icon.png" />

                        <span class="tooltiptext">{{ student.remark }}</span></span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import RegisterClass from "../../services/registerClass.service";
import pagination from "../../components/navigation/Pagination";
import vSelect from "vue-select";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import frLocale from "@fullcalendar/core/locales/fr";
import moment from "moment";

export default {
  name: "ShowRegisterPresenc",
  components: {
    TopTemplate,
    FullCalendar,
    pagination,
    "v-select": vSelect,
    Datepicker,
  },

  data() {
    return {
      isSelected: false,
      inputText: false,
      options: {
        dateClick: this.handleDateClick,
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        locale: frLocale,
        selectable: true,
        select: this.handleSelect,
        headerToolbar: {
          left: "prev",
          center: "title",
          right: "next",
        },
        eventDidMount: this.eventDidMount,
        dateClick: this.handleDateClick,

        eventClassNames: this.setEventClass,
        editable: true,
        events: [],
      },
      isEventHarnessEmpty: true,
      moment: null,
      timesheets: [],

      loading: false,
      search: true,
      register: [],
      selected: [],
      total: 0,
      pagination: {},
      currentPage: 1,
      students: [],
      nbPage: 20,
      params: {
        q: "",
        limit: null,
        page: 1,
        sort: "due_date",
        class_school_id: 1,
        course_id: [],
        class_ids: "",
        class_type_id: null,
        order: false,
        class: null,
        date: "",
      },
      selectedLevel: null,
      selectedClass: null,
      last_page: null,
      selectedCourse: null,
      classes: [],
      courses: [],
      levels: [],
      stats: [],
      moment: null,
      hasCustomEvent: false,
    };
  },
  computed: {
    formattedDate() {
      return this.params.date ? moment(this.params.date).format("DD MMMM YYYY") : null;
    },
  },
  created() {
    this.moment = moment;
  },

  mounted() {
    this.params.limit = this.nbPage;
    this.params.date = moment().format("YYYY-MM-DD");

    this.ListClass();
  },
  methods: {
    eventDidMount(info) {
      if (info === undefined) {
        const active = document.querySelectorAll(".fc-scrollgrid-sync-inner");
        active.forEach((element) => {
          element.classList.remove("custom-class");
        });
      } else {
        const tdElement = info.el.closest(".fc-daygrid-day-frame");

        if (tdElement) {
          tdElement.classList.add("custom-class");
        }
      }
    },

    setEventClass(type) {
      // Fonction pour définir les classes des événements
      const classNames = ["custom-event"];
      return classNames;
    },
    handleDayHeaderMount(info) {
      const tdElement = info.el.closest("td");

      if (tdElement) {
        tdElement.classList.add("custom-class");
      }
    },

    handleDateClick: function (arg) {
      const tdElement = arg.dayEl;
      const eventElement = arg.el;
      const activeTDElements = document.querySelectorAll(".active-td");
      const active = document.querySelectorAll(".fc-day-today");
      active.forEach((element) => {
        element.classList.remove("fc-day-today");
      });
      activeTDElements.forEach((element) => {
        element.classList.remove("active-td");
      });
      if (tdElement) {
        tdElement.classList.add("active-td");
      }
      if (eventElement) {
        eventElement.classList.add("active-td");
      }

      if (this.params.date != null) {
        this.params.date = this.dateTime(arg.dateStr);
      }
      this.getResults();
    },

    convertToEvents(data) {
      this.options.events = data.map((item) => ({
        title: item.count,
        start: item.date,
      }));
    },

    absentStudents(timesheet) {
      return timesheet.students.filter((student) => student.status === 1);
    },
    delayedStudents(timesheet) {
      return timesheet.students.filter((student) => student.status === 2);
    },
    excluStudents(timesheet) {
      return timesheet.students.filter((student) => student.status === 4);
    },
    presentWithRemarkStudents(timesheet) {
      return timesheet.students.filter((student) => student.status === 3 && student.remark != null);
    },

    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },

    formatHours(date) {
      const heure = date.split(":")[0];
      const minute = date.split(":")[1];
      return `${heure}h${minute}`;
    },

    toggleCollapse(index) {
      this.register[index].expanded = !this.register[index].expanded;
    },
    resetFilter() {
      this.inputText = false;
      this.isSelected = false;
      this.selectedClass = null;
      this.selectedLevel = [];
      this.params.class = [];
      this.params.class = null;
      this.FilterRegister();
      this.getResults(true);
      this.eventDidMount();
    },
    FilterRegister() {
      RegisterClass.getFilter({
        params: {},
      }).then(
        (response) => {
          this.levels = response.data.types;
        },
        (error) => {
          console.error(error);
        }
      );
    },

    StatsRegister(id) {
      RegisterClass.getStats(id).then(
        (response) => {
          this.stats = response.data;
          const unwrappedEvents = Array.from(this.stats);
          this.convertToEvents(unwrappedEvents);
        },
        (error) => {
          console.error(error);
        }
      );
    },

    ListClass() {
      RegisterClass.getClass({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          //sort: this.params.sort,
          order: this.params.order,
          class: this.params.class,
        },
      }).then(
        (response) => {
          this.FilterRegister();
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
        },
        (error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push("/error-403");
          }
          console.error(error);
        }
      );
    },

    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },

    ChangeClass(e) {
      this.selectedCourse = null;
      this.params.course_id = [];
      if (e != null) {
        this.params.class = [];
        this.params.class = e.id;

        this.courses = _.orderBy(e.courses, "name");
      } else {
        this.params.class = [];
        this.StatsRegister();
        this.eventDidMount();
      }
      this.getResults();
    },

    ChangeLevel(e) {
      if (e != null) {
        this.courses = [];
      } else {
        this.params.class = null;
        this.isSelected = false;
        this.selectedLevel = null;
      }
      this.params.course_id = [];
      this.selectedClass = null;
      this.selectedCourse = null;
      this.params.class_school_id = [];
      this.params.page = 1;
      this.isSelected = true;
      if (e) {
        this.classes = _.orderBy(e?.classe, "name");
        this.courses = _.orderBy(e.classe?.courses, "name");
      } else {
        this.StatsRegister();
        this.getResults();
        this.eventDidMount();
      }
    },
    getResults(page = null, reset) {
      this.inputText = false;
      this.loading = false;

      this.selected = [];
      this.StatsRegister(this.params.class);
      this.params.page = !page ? this.params.page : page;
      //this.loading = true;
      RegisterClass.getClass({
        params: {
          q: this.params.q,
          limit: this.params.limit,
          page: this.params.page,
          //sort: this.params.sort,
          order: this.params.order,
          class_school_id: this.params.class_type_id,
          class: this.params.class,
          date: this.params.date,
        },
      })
        .then(
          (response) => {
            this.register = response.data.data.map((item) => ({
              ...item,
              isCollapsed: true,
            }));
            if (reset) {
              this.selectedClass = null;
            }

            this.inputText = true;
            this.register = response.data.data;
            this.timesheets = Array.from(this.register);
            this.pagination = this.makePagination(response.data.meta, response.data.links);
            this.total = response.data.meta.total;
          },
          (error) => {
            console.error(error);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.mark {
  position: relative;
  background-color: transparent;
  display: inline-flex;
  border-radius: 50%;
  top: 2px;
  font-size: 0px;
  .tooltiptext {
    visibility: hidden;
    width: max-content;
    background-color: #377879;
    color: white;
    text-align: center;
    padding: 15px;
    position: absolute;
    z-index: 1;
    font-size: 10px;
    top: -45px;
    transform: translateX(-50%);
    left: 10px;
    font-size: 10px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    border-radius: 10px;
  }

  &:hover {
    color: #34b9bb;
    .tooltiptext {
      visibility: visible;
    }
  }
}
.general-info .panel {
  margin-top: 10px;
}
.reset_note {
  color: #34b9bb;
  font-size: 14px;
  font-weight: 600;
}

.top-filter {
  padding-bottom: 0;
  margin: 0;
  padding-top: 15px;

  .info-filter {
    padding: 0;
  }
}

.vs__selected-options input {
  font-size: 12px !important;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  color: black;
}

.top-register {
  padding: 0;
}

.supparation {
  width: 100%;
  margin: 16px 0 19px 0;
  border-top: 1px solid #e0e7ed;
}
.general-info {
  margin-bottom: 10px;
  padding: 15px 20px;
}
.accordion {
  display: flex;
  justify-content: space-between;
}
</style>
